import tinymce from 'tinymce/tinymce';

export default function () {

	tinymce.PluginManager.add('accordeon', function (editor, url) {

		const insertTemplate = () => {
			const html = `<div class="accordeon">
				<div class="accordeon-header">header</div>
				<div class="accordeon-body">body</div>
			</div>`;
			editor.insertContent(html, { format: 'raw' });
		};

		// Add a button that opens a window
		editor.ui.registry.addButton('accordeon', {
			text: 'Accordeon',
			onAction: function () {
				insertTemplate();
			}
		});

		// Adds a menu item, which can then be included in any menu via the menu/menubar configuration
		editor.ui.registry.addMenuItem('accordeon', {
			text: 'Accordeon',
			onAction: function () {
				insertTemplate();
			}
		});

		return {
			getMetadata: function () {
				return {
					name: "Example plugin",
					url: "http://exampleplugindocsurl.com"
				};
			}
		};
	});

};
